import { Button, MultiSelectDropDown } from '@/components/Common';
import { useTipStore } from '@/store/TipStore/TipStore';
import { useTipsList } from './TipsList.hook';

const TipFilter = () => {
  const { setIsOpenForm, handleStatusFilterChange } = useTipsList();

  const openCreateFaq = () => {
    setIsOpenForm(true);
  };
  const { selectedTip } = useTipStore();

  return (
    <div className="flex gap-2 items-center justify-between">
      <div className="flex flex-col">
        <h2 className="text-white text-[32px] font-bold">
          {selectedTip?.name}
        </h2>
      </div>

      <div className="flex items-start gap-4 w-[40%]">
        <MultiSelectDropDown
          options={[
            { _id: 'true', name: 'Publié' },
            { _id: 'false', name: 'Brouillon' },
          ]}
          handleChange={handleStatusFilterChange}
          placeholder="Status"
        />
        <Button title="Ajouter une question" onClick={openCreateFaq} />
      </div>
    </div>
  );
};

export default TipFilter;
